import { buildSampleGrid } from "./shadingTable";
import { moduleQuad } from "./moduleLayout";

/** Enumerate the electrical route without inventing modules in empty slots. */
export function modulePositions(layout, tiers = 1) {
  if (!layout?.check?.consistent) return [];
  return (layout.strings || []).flatMap((s) => s.module_positions || Array.from({ length: s.modules }, (_, i) => ({
    module_id: `${s.string_id}-M${String(i + 1).padStart(3, "0")}`, string_id: s.string_id,
    inverter: s.inverter, mppt: s.mppt, input: s.input, sequence: i + 1,
    row: s.row, column: s.column + Math.floor(i / tiers), tier: i % tiers,
  })));
}
export function moduleSamples(rows, positions, tiers = 1, resolution = 4, offsets = {}, groundZ) {
  return positions.flatMap((p, index) => {
    const row = rows[p.row - 1];
    if (!row || p.column < 0 || p.column >= row.modules || p.tier < 0 || p.tier >= tiers) throw new Error("Module position is outside its physical table.");
    const quad = moduleQuad(row, p, tiers, offsets, groundZ);
    return buildSampleGrid([quad], { across: resolution, up: resolution }).map((sample) => ({ ...sample, row: p.row - 1, module: index }));
  });
}

export function groupModuleShading(modules) {
  const groups = new Map();
  (modules || []).forEach((m) => {
    if (!groups.has(m.string_id)) groups.set(m.string_id, { string_id: m.string_id, inverter: m.inverter, mppt: m.mppt, modules: 0, worst: 0 });
    const group = groups.get(m.string_id); group.modules += 1;
    group.worst = Math.max(group.worst, ...m.values.filter((v) => v >= 0));
  });
  return [...groups.values()];
}
